<template>
  <div
    class="pointer button-item-handler white--text no-decoration description" @click="openHelperPopup"
  >
    <app-icon name="book" :size="18" />
    metodika
  </div>
</template>

<script>
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "MedoticTable",
  components: { AppIcon },
  props: {
    rules: [Array, null],
  },
  methods: {
    openHelperPopup () {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: "full-width",
        payload: null,
        component: "ApplicationHelpPopUp",
        rules: ['single'],
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
